import { v4 as uuid } from 'uuid';

// Keep the same key after an uncertain response; a new input or acknowledged
// submission gets a new key. Legacy producers ignore this optional header.
export const archiveRequest = (payload, previous) => {
	const signature = JSON.stringify(payload);
	const pending = previous?.signature === signature ? previous : { signature, key: uuid() };
	return { request: { data: payload, headers: { 'Idempotency-Key': pending.key } }, pending };
};
